import React, { useState, useEffect } from "react";
import axios from "axios";
import { useForm } from "react-hook-form";
import { useNavigate, Link } from "react-router-dom";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import Swal from "sweetalert2";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import Sidebar from "../../../../components/sidebar/Sidebar";
import Navbar from "../../../../components/navbar/Navbar";
import Loader from "../../../../components/Loader/Loader";
import "../../../../components/common/css/new.scss";
import "../../../Others/Aboutus/Add/addnew.scss";

const Add = () => {
  const [content_en, setContentEn] = useState("");
  const [content_fr, setContentFr] = useState("");
  const [content_it, setContentIt] = useState("");
  const [content_sp, setContentSP] = useState("");
  const [content_pl, setContentPL] = useState("");

  const [loading, setLoading] = useState(false);
  let token = localStorage.getItem("accessToken");
  const navitage = useNavigate();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    mode: "all",
  });

  const onSubmit = (data) => {
    setLoading(true);
    var config = {
      method: "post",
      url: process.env.REACT_APP_API + "save-faq-que-ans",
      headers: {
        "x-access-token": token,
      },
      data: {
        en_question: data.en_question,
        fr_question: data.fr_question,
        it_question: data.it_question,
        es_question: data.es_question,
        pl_question: data.pl_question,
        es_answer: content_sp,
        en_answer: content_en,
        fr_answer: content_fr,
        it_answer: content_it,
        pl_answer: content_pl,
        type: "offeror",
        display_order: data.display_order,
      },
    };

    axios(config)
      .then(function (response) {
        setLoading(false);
        if (response.data.success === true) {
          Swal.fire({
            title: response.data.message,
            timer: 2500,
            timerProgressBar: true,
            icon: "success",
            confirmButtonText: "OK",
            showCloseButton: true,
          });
          navitage("/offeror-faq");
        }
      })
      .catch(function (error) {
        setLoading(false);
        Swal.fire({
          title: error.response.data.message,
          timerProgressBar: true,
          icon: "error",
          confirmButtonText: "OK",
          showCloseButton: true,
        });
      });
  };

  return (
    <div className="new">
      <Sidebar />
      <div className="newContainer">
        <Navbar />
        <Loader isLoading={loading} />
        <div className="bottom">
          <div>
            <div className="modal-content-title">Add Investor Faq</div>
            <p>&nbsp;</p>
            <form onSubmit={handleSubmit(onSubmit)} className="faq-form">
              <div className="custome-form-group">
                <label>English Question* : </label>
                <input
                  type="text"
                  name="en_question"
                  {...register("en_question", {
                    required: "This field is required",
                  })}
                  className="custome-input"
                />
                {errors.en_question && (
                  <div className="invalid-feedback">
                    {errors.en_question.message}
                  </div>
                )}
              </div>
              <div className="custome-form-group">
                <label>French Question* :</label>
                <input
                  type="text"
                  name="fr_question"
                  {...register("fr_question", {
                    required: "This field is required",
                  })}
                  className="custome-input"
                />
                {errors.fr_question && (
                  <div className="invalid-feedback">
                    {errors.fr_question.message}
                  </div>
                )}
              </div>

              <div className="custome-form-group">
                <label>Italian Question* :</label>
                <input
                  type="text"
                  name="it_question"
                  {...register("it_question", {
                    required: "This field is required",
                  })}
                  className="custome-input"
                />
                {errors.it_question && (
                  <div className="invalid-feedback">
                    {errors.it_question.message}
                  </div>
                )}
              </div>
              <div className="custome-form-group">
                <label>Spanish Question* :</label>
                <input
                  type="text"
                  name="es_question"
                  {...register("es_question", {
                    required: "This field is required",
                  })}
                  className="custome-input"
                />
                {errors.es_question && (
                  <div className="invalid-feedback">
                    {errors.es_question.message}
                  </div>
                )}
              </div>
              <div className="custome-form-group">
                <label>Polish Question* :</label>
                <input
                  type="text"
                  name="pl_question"
                  {...register("pl_question", {
                    required: "This field is required",
                  })}
                  className="custome-input"
                />
                {errors.pl_question && (
                  <div className="invalid-feedback">
                    {errors.pl_question.message}
                  </div>
                )}
              </div>
              <div className="custome-form-group">
                <label>Display Order</label>
                <input
                  type="text"
                  name="display_order"
                  {...register("display_order", {
                    required: "This field is required",
                  })}
                  className="custome-input"
                />
                {errors.display_order && (
                  <div className="invalid-feedback">
                    {errors.display_order.message}
                  </div>
                )}
              </div>
              <div className="custome-form-group">
                <label>English Answer* :</label>
                <CKEditor
                  editor={ClassicEditor}
                  data={content_en}
                  config={{
                    link: {
                      addTargetToExternalLinks: true,
                      decorators: {
                        openInNewTab: {
                          mode: "manual",
                          label: "Open in a new tab",
                          attributes: {
                            target: "_blank",
                            rel: "noopener noreferrer",
                          },
                        },
                      },
                    },
                  }}
                  name="aboutcontent_en"
                  onChange={(e, editor) => {
                    const data = editor.getData();
                    setContentEn(data);
                  }}
                />
              </div>
              <div className="custome-form-group">
                <label>French Answer* :</label>
                <CKEditor
                  editor={ClassicEditor}
                  data={content_fr}
                  config={{
                    link: {
                      addTargetToExternalLinks: true,
                      decorators: {
                        openInNewTab: {
                          mode: "manual",
                          label: "Open in a new tab",
                          attributes: {
                            target: "_blank",
                            rel: "noopener noreferrer",
                          },
                        },
                      },
                    },
                  }}
                  name="aboutcontent_fr"
                  onChange={(e, editor) => {
                    const data = editor.getData();
                    setContentFr(data);
                  }}
                />
              </div>
              <div className="custome-form-group">
                <label>Italian Answer* :</label>
                <CKEditor
                  editor={ClassicEditor}
                  data={content_it}
                  config={{
                    link: {
                      addTargetToExternalLinks: true,
                      decorators: {
                        openInNewTab: {
                          mode: "manual",
                          label: "Open in a new tab",
                          attributes: {
                            target: "_blank",
                            rel: "noopener noreferrer",
                          },
                        },
                      },
                    },
                  }}
                  name="aboutcontent_it"
                  onChange={(e, editor) => {
                    const data = editor.getData();
                    setContentIt(data);
                  }}
                />
              </div>
              <div className="custome-form-group">
                <label>Spanish Answer* :</label>
                <CKEditor
                  editor={ClassicEditor}
                  data={content_sp}
                  config={{
                    link: {
                      addTargetToExternalLinks: true,
                      decorators: {
                        openInNewTab: {
                          mode: "manual",
                          label: "Open in a new tab",
                          attributes: {
                            target: "_blank",
                            rel: "noopener noreferrer",
                          },
                        },
                      },
                    },
                  }}
                  name="aboutcontent_sp"
                  onChange={(e, editor) => {
                    const data = editor.getData();
                    setContentSP(data);
                  }}
                />
              </div>
              <div className="custome-form-group">
                <label>Polish Answer* :</label>
                <CKEditor
                  editor={ClassicEditor}
                  data={content_pl}
                  config={{
                    link: {
                      addTargetToExternalLinks: true,
                      decorators: {
                        openInNewTab: {
                          mode: "manual",
                          label: "Open in a new tab",
                          attributes: {
                            target: "_blank",
                            rel: "noopener noreferrer",
                          },
                        },
                      },
                    },
                  }}
                  name="aboutcontent_pl"
                  onChange={(e, editor) => {
                    const data = editor.getData();
                    setContentPL(data);
                  }}
                />
              </div>
              <div className="custome-form-group"></div>
              <button type="submit" className="approveButton">
                Save
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Add;
